var e="undefined"==typeof window||"undefined"==typeof document;export{e as isNotBrowser};
//# sourceMappingURL=isNotBrowser.js.map
